export const baseURL = "https://admin.shorashori.live/";
export const secretKey = "9&*a)y-ej=pd6w@bb&g6xy1z!#a0&_+4c$y_6)fgt=m6zc^r*d";
export const projectName = "Shorashori";
